import { render, staticRenderFns } from "./raffleLayer.vue?vue&type=template&id=b2f63c4e&scoped=true&"
import script from "./raffleLayer.vue?vue&type=script&lang=js&"
export * from "./raffleLayer.vue?vue&type=script&lang=js&"
import style0 from "./raffleLayer.vue?vue&type=style&index=0&id=b2f63c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f63c4e",
  null
  
)

export default component.exports